import type { HTMLAttributes } from "react";

type Tone = "neutral" | "market" | "signal";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
}

const tones: Record<Tone, string> = {
  neutral: "bg-sand/40 text-ink",
  market: "bg-market-subtle text-market-hover",
  signal: "bg-signal-subtle text-signal-hover",
};

export function Badge({ tone = "neutral", className = "", children, ...rest }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 font-mono text-xs uppercase tracking-wide ${tones[tone]} ${className}`}
      {...rest}
    >
      {children}
    </span>
  );
}
